function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 22h9.5c1.398 0 2.097 0 2.648-.228a3 3 0 001.624-1.624C22 19.597 22 18.898 22 17.5V17c0-.93 0-1.395-.102-1.777a3 3 0 00-2.122-2.12C19.395 13 18.93 13 18 13v0m-6-6l1.119-1.12c.706-.706 1.06-1.059 1.431-1.264a3 3 0 012.899 0c.372.205.725.558 1.431 1.265v0c.649.648.973.972 1.171 1.318a3 3 0 01.13 2.734c-.165.363-.457.716-1.04 1.423L12 20m-4.5-3a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1m5.5 5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C9.72 2 8.88 2 7.2 2h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C2 4.28 2 5.12 2 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C4.28 22 5.12 22 6.8 22H12z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAppearance = function SvgAppearance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#9193A9"
  }, props), _ref);
};

export default SvgAppearance;